<template>
  <base-section
    id="team"
  >
    <base-section-heading title="Unser Team" />
    <v-responsive
      class="mx-auto"
      max-width="1350"
    >
      <v-container fluid>
        <v-row
          class="d-flex justify-center"
        >
          <v-col
            v-for="card in cards"
            :key="card.title"
            cols="12"
            sm="3"
            md="3"
          >
            <base-team-card
              align="center"
              light
              :frame="true"
              v-bind="card"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionTeam',

    data: () => ({
      cards: [
        {
          icon: 'Linda_Ifea_small.jpg',
          title: 'Linda Castioni',
          subtitle: 'Treuhänderin mit eidg. FA',
          text: 'Geschäftsleitung und Inhaberin',
        },
        /* {
          icon: 'Claudia_Ifea_small.jpg',
          subtitle: 'Fachfrau Finanz- & Rechnungswesen eidg. FA',
          title: 'Claudia Castioni',
          text: 'Mandatsleiterin',
        }, */
        {
          icon: 'Glorian_Ifea_small.jpg',
          subtitle: 'dipl. Betriebswirtschafter HF',
          title: 'Glorian Gashi',
          text: 'Mandatsleiter',
        },
      ],
    }),
  }
</script>
